module.exports = __webpack_public_path__ + "static/media/IconTemplates_-18.b2d2f641.svg";